import { useEffect, useState } from "react";
import { CardTaps } from "../../../../../theme/Component/CardTaps";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _Affiliate, _DocumentAffiliateRecord, _RequestCredit, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { ObjectDinamicViewer } from "../../../../../contract/etapa-contrato/contrac/ublinvoice/FireElectronicDocument/ObjectDinamicViewer/ObjectDinamicViewer";
import { PersonalAccountData } from "../../../../../../portal/componets/pages/IndexPage/Components/PersonarDataUser/PersonalAccountData";
import { BasicSwitch } from "../../../../../theme/Component/BasicSwitch";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { PersonalInfoAfiliates } from "./PersonalInfoAfiliates";
import { MASK_MONEY } from "../../../../../theme/Component/BasicTable";
import { PrintJson } from "../../../../../theme/Component/PrintJson";

interface Props {
    objectUpdate: any;
    Props: any;
    onUpdate: Function;
    pushProps?: Function;
    pushInfo?: Function;
}


interface CheckList {
    Location: boolean;
    LocationCodeudor: boolean;
    Reference: boolean;
    RederenceCodeudor: boolean;
}

export const CreditDetailsRef = ({ Props, onUpdate, objectUpdate, pushInfo, pushProps }: Props) => {

    const { instance, bean, setBean } = useDataBean(_Affiliate);
    const doc = useDataBean(_DocumentAffiliateRecord);
    const request = useDataBean(_RequestCredit);

    const [credit, setCredit] = useState<any>({});
    const [codeudor, setCodeudor] = useState<any>({});
    const [deudor, setDeudor] = useState<any>({});
    const [check, setCheck] = useState<any>({
        Location: false,
        LocationCodeudor: false,
        Reference: false,
        RederenceCodeudor: false
    });
    const [notes, setNotes] = useState<any[]>([]);
    const [props, setProps] = useState<any>({});



    const [taps, setTaps] = useState<any[]>([
        { id: 0, name: 'Deudor/Codeudor', disable: false },
        // { id: 1, name: 'Documentos', disable: false },
        { id: 2, name: 'Información Credito', disable: false },
        { id: 3, name: 'Observaciones', disable: false },
        { id: 4, name: 'Validacion de Datos', disable: false },
        // { id: 4, name: 'Consultar Deudas y Codeudas', disable: false },
        // { id: 5, name: 'Validacion de Datos', disable: false },
        // { id: 6, name: 'Libre Inversión', disable: false },
    ])

    const [indexTap, setIndexTap] = useState(0);

    useEffect(() => {

        if (Props.Credito) {
            setCredit(Props.Credito)
        }
        if (Props.Codeudor) {
            setCodeudor(Props.Codeudor)
        }
        if (Props.Notas) {
            setNotes(Props.Notas)
        }
        if (Props.CheckList && typeof Props.CheckList === 'object') {
            setCheck(prev => ({
                ...prev,
                ...Props.CheckList
            }));
        }
        if (Props.RProps) {
            const x = Props.RProps;
            setProps(x);
        }

        if (Props.JSONDeudor) {
            setDeudor(Props.JSONDeudor)
        }
    }, [Props])

    useEffect(() => {
        if (indexTap == 5) {
            getDocumentCreditByAffiliate(Props.JSONDeudor.IDAccount);
        }
    }, [indexTap])

    const getDocumentCreditByAffiliate = (idAcc) => {
        doc.instance.getDocumentCreditByAffiliate(idAcc).then(
            (resp: any) => {
                let temp = resp.filter((item) => item.DataBeanProperties.RoleSubmit == 101);
                doc.setLista(temp);
            }
        )
    }

    // const getInfoBasica = () => {
    //     instance.getCreditAffiliateRender(Props.procedure.IDAccountProcedureImp).then(
    //         (resp) => {
    //             setBean(resp)
    //         }
    //     ).catch(err => { toast.error(err) })
    // }

    const updateCredit = (value) => {
        request.instance.updateRequestCredit(value).then(
            (resp) => {
                toast.success("Información actualizada correctamente.");
                onUpdate?.();
            }
        ).catch(err => { toast.error(err) })
    }

    const addNote = () => {
        if (!bean.Message || bean.Message.trim() === "") {
            toast.warning("Por favor, escribe un mensaje antes de agregar una nota.");
            return;
        }

        const newNote = {
            DataBeanProperties: {
                IDEmployee: _single.getAccountID(),
                Employee: _single.getAccount().Name1 + " " + _single.getAccount().Surname1,
                Message: bean.Message,
                Since: new Date().toLocaleString(),
            },
        };

        const updatedNotes = Array.isArray(notes) ? [...notes, newNote] : [newNote];

        setNotes(updatedNotes);
        setBean((prevBean) => ({ ...prevBean, Message: "" }));

        // Solo actualiza el crédito aquí
        const x = {
            ...objectUpdate,
            JSONNotes: JSON.stringify(updatedNotes)
        };
        updateCredit(x);
    };



    const replacements: Record<string, string> = {
        Location: "Datos de ubicación y contacto",
        LocationCodeudor: "Datos de Ubicacion y contacto Codeudor",
        Reference: "Referencia Familiar y personal Deudor",
        RederenceCodeudor: "Referencia Familiar y personal Codeudor",
        CapDeudor: "Capacidad de Endeudamiento (Deudor)",
        RiskCentral: "Centrales de Riesgo",
        Signed: "Huellas y Firmas",
        Months: "Plazos",
    };

    const formatPropertyName = (name: string) => {
        if (replacements[name]) return replacements[name];

        return name
            .replace(/([A-Z])/g, ' $1')
            .replace(/[_-]/g, ' ')
            .replace(/\b\w/g, char => char.toUpperCase())
            .trim();
    };

    const formatCheckToTable = (check: any, trueLabel = "Validado", falseLabel = "No Validado") => {
        const formatted = {};

        Object.entries(check).forEach(([key, value]) => {
            formatted[formatPropertyName(key)] = value === true ? trueLabel : falseLabel;
        });

        return formatted;
    };

    return (
        <CardTaps index={indexTap} taps={taps} updateIndex={setIndexTap} >

            {indexTap === 0 &&
                <div className="row">
                    <div className="col-md-12">
                        <PersonalInfoAfiliates requestBean={objectUpdate} props={props} />
                    </div>
                </div>
            }

            {indexTap === 1 &&
                <div className="row">
                    <div className="col-md-12">
                        <PersonalAccountData showOnlyTabId={2} idAffiliate={props.IDAccount} />
                    </div>
                </div>
            }

            {indexTap === 2 &&
                <div className="row">
                    {objectUpdate.AmountCredit &&
                        <>
                            <div className="col-md-12">
                                <h5>Credito</h5>
                            </div>
                            <div className="col-md-12 d-flex justify-content-between align-items-center">
                                <strong>Linea de Credito:</strong>
                                <div dangerouslySetInnerHTML={{ __html: credit.Name }}></div>
                            </div>
                            <div className="col-md-12 d-flex justify-content-between align-items-center">
                                <strong>Valor Solicitado:</strong>
                                <div dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(objectUpdate.AmountCredit, MASK_MONEY) }}></div>
                            </div>
                            <div className="col-md-12 d-flex justify-content-between align-items-center">
                                <strong>Valor Valor Aprobado (Analista):</strong>
                                <div dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(objectUpdate.AmountApprove, MASK_MONEY) }}></div>
                            </div>
                        </>
                    }
                    {objectUpdate.Cuotes &&
                        <div className="col-md-12 d-flex justify-content-between align-items-center">
                            <strong>Cuotas:</strong>
                            <div dangerouslySetInnerHTML={{ __html: objectUpdate.Cuotes }}></div>
                        </div>
                    }
                    {objectUpdate.AmountTax &&
                        <div className="col-md-12 d-flex justify-content-between align-items-center">
                            <strong>Procentaje:</strong>
                            <div dangerouslySetInnerHTML={{ __html: `${objectUpdate.AmountTax}%` }}></div>
                        </div>
                    }

                    <div className="col-md-12">
                        <hr />
                    </div>
                    {objectUpdate.IDAccount &&
                        <>
                            <div className="col-md-12">
                                <h5>Deudor</h5>
                            </div>
                            <div className="col-lg-6 my-2">
                                <strong>Nombres y Apellidos:</strong>
                                <div dangerouslySetInnerHTML={{ __html: `${deudor.PrimerNombre} ${deudor.SegundoNombre} ${deudor.PrimerApellido} ${deudor.SegundoApellido}` }}></div>
                            </div>
                            <div className="col-lg-6 my-2">
                                <strong>Grado:</strong>
                                <div dangerouslySetInnerHTML={{ __html: `${deudor.IDGradoPersonaName}` }}></div>
                            </div>
                            <div className="col-lg-6 my-2">
                                <strong>Tipo de Identificación:</strong>
                                <div dangerouslySetInnerHTML={{ __html: `${deudor.IDTipoIdentificacionName}` }}></div>
                            </div>
                            <div className="col-lg-6 my-2">
                                <strong>Numero de Identificación:</strong>
                                <div dangerouslySetInnerHTML={{ __html: `${deudor.Nit}` }}></div>
                            </div>
                            <div className="col-lg-6 my-2">
                                <strong>Caja Nominadora:</strong>
                                <div dangerouslySetInnerHTML={{ __html: `${deudor.IDCajaNominadoraName ?? "N/A"}` }}></div>
                            </div>
                            <div className="col-lg-6 my-2">
                                <strong>Tiempo de Servicio:</strong>
                                <div dangerouslySetInnerHTML={{ __html: `${deudor.TiempoServicio ?? "N/A"}` }}></div>
                            </div>
                            <div className="col-lg-6 my-2">
                                <strong>Correo Personal:</strong>
                                <div dangerouslySetInnerHTML={{ __html: `${deudor.CorreoPersonal}` }}></div>
                            </div>
                            <div className="col-lg-6 my-2">
                                <strong>Correo Institucional:</strong>
                                <div dangerouslySetInnerHTML={{ __html: `${deudor.CorreoInstitucional}` }} />
                            </div>
                        </>
                    }
                    <div className="col-md-12">
                        <hr />
                    </div>
                    {objectUpdate.IDAccountCodeuda &&
                        <>
                            <div className="col-md-12">
                                <h5>Codeudor</h5>
                            </div>
                            <div className="col-lg-6 my-2">
                                <strong>Nombres y Apellidos:</strong>
                                <div dangerouslySetInnerHTML={{ __html: `${codeudor.PrimerNombre} ${codeudor.SegundoNombre} ${codeudor.PrimerApellido} ${codeudor.SegundoApellido}` }}></div>
                            </div>
                            <div className="col-lg-6 my-2">
                                <strong>Grado:</strong>
                                <div dangerouslySetInnerHTML={{ __html: `${codeudor.IDGradoPersonaName}` }}></div>
                            </div>
                            <div className="col-lg-6 my-2">
                                <strong>Tipo de Identificación:</strong>
                                <div dangerouslySetInnerHTML={{ __html: `${codeudor.IDTipoIdentificacionName}` }}></div>
                            </div>
                            <div className="col-lg-6 my-2">
                                <strong>Caja Nominadora:</strong>
                                <div dangerouslySetInnerHTML={{ __html: `${codeudor.IDCajaNominadoraName ?? "N/A"}` }}></div>
                            </div>
                            <div className="col-lg-6 my-2">
                                <strong>Tiempo de Servicio:</strong>
                                <div dangerouslySetInnerHTML={{ __html: `${codeudor.TiempoServicio ?? "N/A"}` }}></div>
                            </div>
                            <div className="col-lg-6 my-2">
                                <strong>Numero de Identificación:</strong>
                                <div dangerouslySetInnerHTML={{ __html: `${codeudor.Nit}` }}></div>
                            </div>
                            <div className="col-lg-6 my-2">
                                <strong>Correo Personal:</strong>
                                <div dangerouslySetInnerHTML={{ __html: `${codeudor.CorreoPersonal}` }}></div>
                            </div>
                            <div className="col-lg-6 my-2">
                                <strong>Correo Institucional:</strong>
                                <div dangerouslySetInnerHTML={{ __html: `${codeudor.CorreoInstitucional}` }}></div>
                            </div>
                        </>
                    }
                </div>
            }

            {indexTap === 3 &&
                <div className="row" style={{ maxHeight: `66vh`, overflow: "auto" }}>
                    <div className="col-md-12" style={{ height: `75%`, overflow: "auto" }}>
                        {Array.isArray(notes) && notes.length > 0 ? (
                            notes.map((Obs, index) => {
                                const Note = Obs.DataBeanProperties;
                                return (
                                    <div className={`row d-flex ${Note.IDEmployee == _single.getAccountID() ? "justify-content-end" : "justify-content-start"}`} key={index}>
                                        <div className={`message ${Note.IDEmployee == _single.getAccountID() ? "admin-message" : "user-message"}`}>
                                            {/* <button className={`delete-btn ${Note.IDEmployee == _single.getAccountID() ? "" : "d-none"}`} onClick={() => deleteNote(Note.IDNoteImp)}>x</button> */}
                                            <div className="col-12 py-2">
                                                <strong>{Note.Employee}:</strong>
                                            </div>
                                            <div className="col-md-12">
                                                <p>{Note.Message}</p>
                                            </div>
                                            <div className="col-12 py-2">
                                                <small>{Note.Since}</small>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <div className="row">
                                <div className="col-md-12 text-center">
                                    <p>No hay notas asignadas</p>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="col-md-12">
                        <hr />
                        <div className="input-group">
                            <textarea className="form-control" value={bean.Message} rows={4} onChange={(e) => { setBean({ ...bean, "Message": e.target.value }) }} style={{ resize: "none" }} />
                            <BasicButton eventClick={() => { addNote() }} icon="ri-edit-2-line" children={"Agregar nota"} />
                        </div>
                    </div>
                </div>
            }

            {indexTap === 4 &&
                <div className="row">
                    <div className="col-md-6">
                        <BasicSwitch estado={check.Location} eventChange={(e) => { setCheck({ ...check, Location: e }) }} label="Datos de ubicación y contacto" />
                    </div>
                    <div className="col-md-6">
                        <BasicSwitch estado={check.LocationCodeudor} eventChange={(e) => { setCheck({ ...check, LocationCodeudor: e }) }} label="Datos de Ubicacion y contacto Codeudor" />
                    </div>
                    <div className="col-md-6">
                        <BasicSwitch estado={check.Reference} eventChange={(e) => { setCheck({ ...check, Reference: e }) }} label="Referencia Familiar y personal Deudor" />
                    </div>
                    <div className="col-md-6">
                        <BasicSwitch estado={check.RederenceCodeudor} eventChange={(e) => { setCheck({ ...check, RederenceCodeudor: e }) }} label="Referencia Familiar y personal Codeudor" />
                    </div>
                    <div className="col">
                        <BasicButton
                            eventClick={() => {
                                if (!objectUpdate || typeof objectUpdate !== 'object') {
                                    toast.warning("La información de actualización no es válida.");
                                    return;
                                }

                                if (!check || typeof check !== 'object') {
                                    toast.warning("La información de validación de datos (check) no es válida.");
                                    return;
                                }

                                const x = {
                                    ...objectUpdate,
                                    JSONCheckList: JSON.stringify(check)
                                };

                                const result = formatCheckToTable(check);
                                pushInfo?.(
                                    _single.jsonToBootstrapTable(result)
                                )

                                updateCredit(x);
                            }}
                            icon="ri-save-line"
                            children="Guardar"
                        />

                    </div>
                </div>
            }


        </CardTaps>
    )
}